import React from 'react';
import { getNewDocuRows } from 'src/pages/OfferPage/TableSvgOrganizer/pureTableBodyUtils';
import { PureTableRow } from 'src/pages/OfferPage/TableSvgOrganizer/PureTableRow';
import { ProjectQuoteUserProperties } from "src/model/api/project.model";
import { GetAllManufacturerDiscountForProjectResponse } from "src/model/api/manufacturer-discount.model";
import { ManufacturerRecommendationResponse } from "src/model/api/manufacturer-recommendation";

export const PureTableBody = React.memo(function WrappedPureTableBody(
    {
      projectId,
      table,
      detailsEnabled,
      rows = table.rows,
      neededCols,
      allCols,
      currency,
      setCustomMinusRowButtonPressed,
      setCustomMinusItem,
      dispatchDownloadStates,
      modifyMode,
      setModifyMode,
      icons,
      currentRowInEditing,
      setCurrentRowInEditing,
      labourCost = null,
      measurementSystem,
      quoteUserProperties,
      allManufacturerDiscountForProject,
      manufacturerRecommendationForProject,
    }: {
      projectId: number;
      table: any;
      detailsEnabled: boolean;
      rows: any;
      neededCols: any;
      allCols: any;
      currency: string;
      setCustomMinusRowButtonPressed: any;
      setCustomMinusItem: any;
      dispatchDownloadStates: any;
      modifyMode: any;
      setModifyMode: any;
      icons: any;
      currentRowInEditing: any;
      setCurrentRowInEditing: any;
      labourCost: any;
      measurementSystem: string;
      quoteUserProperties: ProjectQuoteUserProperties;
      allManufacturerDiscountForProject: GetAllManufacturerDiscountForProjectResponse;
      manufacturerRecommendationForProject: ManufacturerRecommendationResponse;
    }
) {

  const [modifyMinusRow, setModifyMinusRow] = React.useState(null);
  const [newRows, setNewRows] = React.useState(rows);

  //REFACT CAUSE LABOUR COST RESET BUTTON
  React.useEffect(() => {
    if(table.entitytype !== "projectcustomtable") {
      setNewRows(getNewDocuRows(table.entitytype, rows))
    } else {
      if(labourCost !== null) {
        const installationRow = rows.find((row: any) => row.specification_type === "installation");
        const personalisationRow = rows.find((row: any) => row.specification_type === "personalisation");
  
        if(installationRow) {
          installationRow[`price_${currency}`] = labourCost.installation.hourlyRate;
          installationRow.quantity = labourCost.installation.hours;
        }
  
        if(personalisationRow) {
          personalisationRow[`price_${currency}`] = labourCost.personalisation.hourlyRate;
          personalisationRow.quantity = labourCost.personalisation.hours;
        }

        setNewRows(rows);
      }
    }
  }, [table.entitytype, rows, labourCost]);

  //check if there are only deleted custom items
  const onlyDeletedCustomItems = newRows.filter((row: any) => row.custom === true).every((row: any) => row.quantity < 0);

  return newRows.length
    ? newRows.map((row: any, index: number) => (
        <React.Fragment key={row.rowIdx ? row.rowIdx : index}>
          {row.isGroupHeading ? (
            <tr className={`group group-start ${onlyDeletedCustomItems ? 'remove-on-export' : ''}`}>
              <td colSpan={neededCols.length}>{row.text}</td>
            </tr>
          ) : (
            <PureTableRow
              projectId={projectId}
              index={index}
              table={table}
              rows={rows}
              row={row}
              neededCols={neededCols}
              currency={currency}
              setCustomMinusRowButtonPressed={setCustomMinusRowButtonPressed}
              setCustomMinusItem={setCustomMinusItem}
              modifyMinusRow={modifyMinusRow}
              setModifyMinusRow={setModifyMinusRow}
              dispatchDownloadStates={dispatchDownloadStates}
              modifyMode={modifyMode}
              setModifyMode={setModifyMode}
              detailsEnabled={detailsEnabled}
              allCols={allCols}
              icons={icons}
              currentRowInEditing={currentRowInEditing}
              setCurrentRowInEditing={setCurrentRowInEditing}
              measurementSystem={measurementSystem}
              quoteUserProperties={quoteUserProperties}
              allManufacturerDiscountForProject={allManufacturerDiscountForProject}
              manufacturerRecommendationForProject={manufacturerRecommendationForProject}
            />
          )}
        </React.Fragment>
      ))
    : null;
});
